
import { Button } from "@/components/ui/button";
import { Eye, EyeOff } from "lucide-react";
import { cn } from "@/lib/utils";
import { SidebarEyeButtonProps } from "./types";

export const SidebarEyeButton = ({ name, feature, isVisible, onEyeClick }: SidebarEyeButtonProps) => {
  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={() => onEyeClick(name, feature)}
      className="text-muted-foreground hover:text-primary"
    >
      {isVisible ? (
        <EyeOff className="h-4 w-4" />
      ) : (
        <Eye className="h-4 w-4" />
      )}
    </Button>
  );
};
